import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OfferLetterList from './offerLetters/OfferLetterList';
import OfferLetterForm from './offerLetters/OfferLetterForm';

const OfferLetters = () => (
  <Routes>
    <Route index element={<OfferLetterList />} />
    <Route path="new" element={<OfferLetterForm />} />
    <Route path=":id" element={<OfferLetterForm />} />
  </Routes>
);

export default OfferLetters;
